import './App.css';
import React from "react";
import ReactDOM from "react-dom";
import { observer } from "mobx-react-lite";
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from 'polotno';
import { Workspace } from "polotno/canvas/workspace";
import { handleHotkey } from 'polotno/canvas/hotkeys';
import {
  SidePanel,
  LayersSection
} from "polotno/side-panel";
import { Toolbar } from "polotno/toolbar/toolbar";
import { ZoomButtons } from "polotno/toolbar/zoom-buttons";
import { createStore } from "polotno/model/store";
import { getImageSize } from "polotno/utils/image";
import {
  Button,
  Navbar,
  Alignment,
  Icon
} from '@blueprintjs/core';
import styled from 'polotno/utils/styled';
import { unstable_registerNextDomDrop } from "polotno/config";
import { isGradient, parseColor } from "polotno/utils/gradient";
import { setColorsPresetFunc } from 'polotno/config';
import {
  FaFlagUsa
} from '@meronex/icons/fa';
import GiHammerSickle from '@meronex/icons/gi/GiHammerSickle';
import FaGlobeAmericas from '@meronex/icons/fa/FaGlobeAmericas';
import { Tabs, Tab } from "@blueprintjs/core";
import { useState } from 'react';
import { Adsense } from '@ctrl/react-adsense';
import { SectionTab } from "polotno/side-panel";
import { ImagesGrid } from "polotno/side-panel/images-grid";
import "@blueprintjs/core/lib/css/blueprint.css";
import TutorialModal from './components/TutorialModal';
import BisBot from '@meronex/icons/bi/BisBot';
import EnStar from '@meronex/icons/en/EnStar';


const store = createStore({
  key: "cWIIWTmkMgSoPVuDcMiK"
});


const NavbarContainer = styled('div')`
  @media screen and (max-width: 500px) {
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100vw;
  }
`;

const NavInner = styled('div')`
  @media screen and (max-width: 500px) {
    display: flex;
  }
`;

store.addPage();

store.setSize(1500, 1000);

store.activePage.addElement({
  type: "svg",
  src: "/wp-content/coamakerbasic/coageneral/Ukraine_blue2.svg",
  height: 500,
  width: 1500,
  x: 0,
  y: 0,
  keepRatio: false,
});

store.activePage.addElement({
  type: "svg",
  src: "/wp-content/coamakerbasic/coageneral/Ukraine_Yellow2.svg",
  height: 500,
  width: 1500,
  x: 0,
  y: 500,
  keepRatio: false,
});

function FlagAdsense() {
  return <div className="flag-top-ad"><Adsense
    client="ca-pub-7706095824493443"
    data-ad-format="fluid"
    data-ad-layout-key="-fb+5w+4e-db+86"
    data-ad-client="ca-pub-7706095824493443"
    data-ad-slot="4392451863"
  /></div>
}

const DEFAULT_COLORS = ['#C60C30', '#B22234', '#FFFFFF', '#003087', '#005BBB', '#74ACDF', '#F2A800', '#FFCC00', '#FDEF42', '#006A44', '#008C45', '#1EB53A', '#000000'];


function sameColors(color1, color2) {
  return color1 === color2;
}

export const getUsedColors = (store) => {
  const colors = [];
  store.pages.forEach((page) => {
    page.children.forEach((element) => {
      if (element.type === 'text') {
        colors.push(element.fill);
      }
      if (element.type === 'svg') {
        colors.push(...Array.from(element.colorsReplace.values()));
      }
    });
  });

  const solidColors = [];
  colors.forEach((color) => {
    if (isGradient(color)) {
      const { stops } = parseColor(color);
      solidColors.push(...stops.map((stop) => stop.color));
    } else {
      solidColors.push(color);
    }
  });

  return [...new Set(solidColors.reverse())];
};

let getColorsPreset = (store) => {
  const colors = getUsedColors(store).slice(0, 40);
  const colorsWithoutDefault = colors.filter((color) => {
    const isDefault = DEFAULT_COLORS.find((c) => sameColors(c, color));
    return !isDefault;
  });

  const preset = colorsWithoutDefault.concat(
    DEFAULT_COLORS.slice(0, 40 - colorsWithoutDefault.length)
  );

  return preset;

};

setColorsPresetFunc((store) => {
  return getColorsPreset(store);
});


const SymbolSection = {
  name: 'symbols',
  Tab: (props) => (
    <SectionTab name="Symbols" {...props}>
      <EnStar />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);

    async function loadImages() {
      const time = (new Date()).getTime();
      const symbolUrl = "/wp-content/coamakerbasic/coa/0_flag.json?=ver";
      const symbolFetch = symbolUrl + time;
      fetch(symbolFetch)
        .then(function (resp) {
          return resp.json();
        })
        .then(function (data) {
          setImages(data);
        });
      //setImages(data.url);
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    React.useEffect(() => {
      loadImages();
    }, []);

    const [coaSearchTerm, setSearchTerm] = useState('');

    var filteredImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "sym")) {
          filteredImages.push(images[i]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
          )) {
          filteredImages.push(images[i]);
        }
      }
    }

    var previewSymbols = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "sym")) {
          previewSymbols.push(images[k]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
          )) {
          previewSymbols.push(images[k]);
        }
      }
    }

    var comImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "com")) {
          comImages.push(images[i]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
          )) {
          comImages.push(images[i]);
        }
      }
    }

    var previewCom = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "com")) {
          previewCom.push(images[k]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
          )) {
          previewCom.push(images[k]);
        }
      }
    }

    var creImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "cre")) {
          creImages.push(images[i]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
          )) {
          creImages.push(images[i]);
        }
      }
    }

    var previewCre = []
    for (var q = 0; q < images.length; q++) {
      let image = images[q];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "cre")) {
          previewCre.push(images[q]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
          )) {
          previewCre.push(images[q]);
        }
      }
    }

    var previewImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (image["pro"] === true) {
        previewImages.push(images[i]);
      }
    }

    var len = previewImages.length

    function CoaElementsPreview(props) {
      return <div className="coam-info-container">
        <hr />
        <div className="coam-info-head">{props.head || "More Elements with PRO"}</div>
        <div className="coam-info-text">{props.text || "Save your designs and use " + len + " extra elements."}</div>
        <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Unlock all elements</span></a></div>
      </div>
    }

    return (
      <div className="Templates-Panel-32" style={{ height: "86%", display: "flex", flexDirection: "column", overflowY: "auto", overflowX: "hidden" }}>
        <FlagAdsense></FlagAdsense>
        <div><input className="coaSearchInput" type="text" placeholder="🔎 Search Symbols" onChange={event => { setSearchTerm(event.target.value) }} /></div>
        <Tabs
          animate={true}
          key={"vertical"}
          vertical={false}
        >
          <Tab id="com" title="Common" panel={
            <div><div style={{ display: "flex", flexDirection: "column" }}>
              <ImagesGrid
                images={comImages}
                getPreview={(image) => image.preview}
                onSelect={async (image) => {
                  let url = image.url;
                  if (url.search(".svg") === -1) {
                    url = `/wp-content/coamakerbasic/${url}.svg`
                  }
                  image.url = url;
                  const { width, height } = await getImageSize(image.url);
                  store.activePage.addElement({
                    type: "svg",
                    src: image.url,
                    width,
                    height,
                    x: (store.width - width) / 2,
                    y: (store.height - height) / 2,
                    keepRatio: false,
                  });
                }}
                rowsNumber={4}
                isLoading={false}
                loadMore={false}
              />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview ></CoaElementsPreview>
                <ImagesGrid
                  images={previewCom}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div></div>
          } />
          <Tab id="cre" title="Creatures" panel={
            <div><div style={{ display: "flex", flexDirection: "column" }}>
              <ImagesGrid
                images={creImages}
                getPreview={(image) => image.preview}
                onSelect={async (image) => {
                  let url = image.url;
                  if (url.search(".svg") === -1) {
                    url = `/wp-content/coamakerbasic/${url}.svg`
                  }
                  image.url = url;
                  const { width, height } = await getImageSize(image.url);
                  store.activePage.addElement({
                    type: "svg",
                    src: image.url,
                    width,
                    height,
                    x: (store.width - width) / 2,
                    y: (store.height - height) / 2,
                    keepRatio: false,
                  });
                }}
                rowsNumber={4}
                isLoading={false}
                loadMore={false}
              />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview ></CoaElementsPreview>
                <ImagesGrid
                  images={previewCre}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div></div>
          } />
          <Tab id="mis" title="Objects" panel={
            <div><div style={{ display: "flex", flexDirection: "column" }}>
              <ImagesGrid
                images={filteredImages}
                getPreview={(image) => image.preview}
                onSelect={async (image) => {
                  let url = image.url;
                  if (url.search(".svg") === -1) {
                    url = `/wp-content/coamakerbasic/${url}.svg`
                  }
                  image.url = url;
                  const { width, height } = await getImageSize(image.url);
                  store.activePage.addElement({
                    type: "svg",
                    src: image.url,
                    width,
                    height,
                    x: (store.width - width) / 2,
                    y: (store.height - height) / 2,
                    keepRatio: false,
                  });
                }}
                rowsNumber={4}
                isLoading={false}
                loadMore={false}
              />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={previewSymbols}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div></div>
          } />
          <Tab id="fup" title="Upload" panel={
            <div style={{ height: '100%' }} className="coa-template-container">
              <b>Uploads are a PRO feature</b>
              <div className="coam-promotion-panel">Do you want to upload your own elements?</div>
              <div className="coam-promotion-panel">With a PRO account you can add every image file you want to your design.</div>
              <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
            </div>

          } /></Tabs>
      </div >
    );
  }),
};

const ShapeSection = {
  name: 'shapes',
  Tab: (props) => (
    <SectionTab name="Flags" {...props} >
      <FaFlagUsa></FaFlagUsa>
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);

    async function loadImages() {
      const time = (new Date()).getTime();
      const shapesUrl = "/wp-content/coamakerbasic/coa/0_flag.json?=ver";
      const shapeFetch = shapesUrl + time;
      console.group(shapeFetch);
      fetch(shapeFetch)
        .then(function (resp) {
          return resp.json();
        })
        .then(function (data) {
          setImages(data);
        });
      //setImages(data.url);
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    React.useEffect(() => {
      loadImages();
    }, []);

    var filteredImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if ((image["pro"] === false) && (image["sec"] === "flag")) {
        filteredImages.push(images[i]);
      }
    }


    var previewImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if ((image["pro"] === true) && (image["sec"] === "flag")) {
        previewImages.push(images[i]);
      }
    }

    var len = previewImages.length

    function CoaElementsPreview(props) {
      return <div className="coam-info-container">
        <hr />
        <div className="coam-info-head">{props.head || "More Flags with PRO"}</div>
        <div className="coam-info-text">{props.text || "Save your designs and use " + len + " extra flags."}</div>
        <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Unlock all elements</span></a></div>
      </div>
    }


    return (
      <div style={{ height: "87%", display: "flex", flexDirection: "column", overflowY: "auto", overflowX: "hidden" }}>
        <FlagAdsense></FlagAdsense>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <ImagesGrid
            images={filteredImages}
            getPreview={(image) => image.preview}
            onSelect={async (image) => {
              let url = image.url;
              if (url.search(".svg") === -1) {
                url = `/wp-content/coamakerbasic/${url}.svg`
              }
              image.url = url;
              const { width, height } = await getImageSize(image.url);
              let StoreWidth = store.width;
              let StoreHeight = store.height;
              store.activePage.addElement({
                type: "svg",
                src: image.url,
                width: StoreWidth,
                height: StoreHeight,
                keepRatio: false
              });
            }}
            rowsNumber={4}
            isLoading={false}
            loadMore={false}
          />
          <div className={"coa-pro-preview"}>
            <CoaElementsPreview ></CoaElementsPreview>
            <ImagesGrid
              images={previewImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
              }}
              rowsNumber={4}
              isLoading={!images.length}
              loadMore={false}
            />
          </div>
        </div>
      </div>

    );
  }),
};


const TemplatesPanel = observer(({ store }) => {


  const [coaSearchTerm, setSearchTerm] = useState('');
  const [images, setImages] = React.useState([]);

  async function loadImages() {
    const templUrl = "/wp-content/coamakerbasic/templates/templates.json?=ver";
    const time = (new Date()).getTime();
    const templFetch = templUrl + time;
    fetch(templFetch)
      .then(function (resp) {
        return resp.json();
      })
      .then(function (data) {
        setImages(data);
      });
    //setImages(data.url);
    await new Promise((resolve) => setTimeout(resolve, 3000));
  }

  React.useEffect(() => {
    loadImages();
  }, []);

  var filteredImages = []
  for (var z = 0; z < images.length; z++) {
    let image = images[z];
    if ((image["pro"] === false) &&
      (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
      )) {
      filteredImages.push(images[z]);
    }
  }

  var amImages = []
  for (var i = 0; i < images.length; i++) {
    let image = images[i];
    if (coaSearchTerm === "") {
      if ((image["sec"].includes("AM"))) {
        amImages.push(images[i]);
      }
    }
    else if (coaSearchTerm !== "") {
      if (
        (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
        )) {
        amImages.push(images[i]);
      }
    }
  }

  var usImages = []
  for (var p = 0; p < images.length; p++) {
    let image = images[p];
    if (coaSearchTerm === "") {
      if ((image["sec"].includes("US"))) {
        usImages.push(images[p]);
      }
    }
    else if (coaSearchTerm !== "") {
      if (
        (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
        )) {
        usImages.push(images[p]);
      }
    }
  }

  var euImages = []
  for (var j = 0; j < images.length; j++) {
    let image = images[j];
    if (coaSearchTerm === "") {
      if ((image["sec"].includes("EU"))) {
        euImages.push(images[j]);
      }
    }
    else if (coaSearchTerm !== "") {
      if (
        (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
        )) {
        euImages.push(images[j]);
      }
    }
  }

  var asImages = []
  for (var k = 0; k < images.length; k++) {
    let image = images[k];
    if (coaSearchTerm === "") {
      if ((image["sec"].includes("AS"))) {
        asImages.push(images[k]);
      }
    }
    else if (coaSearchTerm !== "") {
      if (
        (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
        )) {
        asImages.push(images[k]);
      }
    }
  }

  var afImages = []
  for (var m = 0; m < images.length; m++) {
    let image = images[m];
    if (coaSearchTerm === "") {
      if ((image["sec"].includes("AF"))) {
        afImages.push(images[m]);
      }
    }
    else if (coaSearchTerm !== "") {
      if (
        (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
        )) {
        afImages.push(images[m]);
      }
    }
  }

  var ocImages = []
  for (var o = 0; o < images.length; o++) {
    let image = images[o];
    if (coaSearchTerm === "") {
      if ((image["sec"].includes("OC"))) {
        ocImages.push(images[o]);
      }
    }
    else if (coaSearchTerm !== "") {
      if (
        (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
        )) {
        ocImages.push(images[o]);
      }
    }
  }

  return (
    <div className="Templates-Panel-32" style={{ height: "86%", display: "flex", flexDirection: "column", overflowY: "auto", overflowX: "hidden" }}>
      <FlagAdsense></FlagAdsense>
      <div><input className="coaSearchInput" type="text" placeholder="🔎 Search Flag" onChange={event => { setSearchTerm(event.target.value) }} /></div>
      <Tabs
        animate={true}
        key={"vertical"}
        vertical={false}
      >
        <Tab id="tam" title="AM" panel={
          <div><ImagesGrid
            shadowEnabled={false}
            images={amImages}
            getPreview={(image) => `/wp-content/coamakerbasic/templates/` + image.preview}
            isLoading={false}
            onSelect={async (image) => {
              // download selected json
              const req = await fetch(`/wp-content/coamakerbasic/templates/${image.json}`);
              const json = await req.json();
              // just inject it into store
              store.loadJSON(json, true);
            }}
            rowsNumber={3}
            getCredit={(image) => image.name}
          />
          </div>
        } />
        <Tab id="tus" title="US" panel={
          <div><ImagesGrid
            shadowEnabled={false}
            images={usImages}
            getPreview={(image) => `/wp-content/coamakerbasic/templates/` + image.preview}
            isLoading={false}
            onSelect={async (image) => {
              // download selected json
              const req = await fetch(`/wp-content/coamakerbasic/templates/${image.json}`);
              const json = await req.json();
              // just inject it into store
              store.loadJSON(json, true);
            }}
            rowsNumber={3}
            getCredit={(image) => image.name}
          />
          </div>
        } />
        <Tab id="teu" title="EU" panel={
          <div><ImagesGrid
            shadowEnabled={false}
            images={euImages}
            getPreview={(image) => `/wp-content/coamakerbasic/templates/` + image.preview}
            isLoading={false}
            onSelect={async (image) => {
              // download selected json
              const req = await fetch(`/wp-content/coamakerbasic/templates/${image.json}`);
              const json = await req.json();
              // just inject it into store
              store.loadJSON(json, true);
            }}
            rowsNumber={3}
            getCredit={(image) => image.name}
          />
          </div>
        } />
        <Tab id="taf" title="AF" panel={
          <div><ImagesGrid
            shadowEnabled={false}
            images={afImages}
            getPreview={(image) => `/wp-content/coamakerbasic/templates/` + image.preview}
            isLoading={false}
            onSelect={async (image) => {
              // download selected json
              const req = await fetch(`/wp-content/coamakerbasic/templates/${image.json}`);
              const json = await req.json();
              // just inject it into store
              store.loadJSON(json, true);
            }}
            rowsNumber={3}
            getCredit={(image) => image.name}
          />
          </div>
        } />
        <Tab id="tas" title="AS" panel={
          <div><ImagesGrid
            shadowEnabled={false}
            images={asImages}
            getPreview={(image) => `/wp-content/coamakerbasic/templates/` + image.preview}
            isLoading={false}
            onSelect={async (image) => {
              // download selected json
              const req = await fetch(`/wp-content/coamakerbasic/templates/${image.json}`);
              const json = await req.json();
              // just inject it into store
              store.loadJSON(json, true);
            }}
            rowsNumber={3}
            getCredit={(image) => image.name}
          />
          </div>
        } />
        <Tab id="toc" title="OC" panel={
          <div><ImagesGrid
            shadowEnabled={false}
            images={ocImages}
            getPreview={(image) => `/wp-content/coamakerbasic/templates/` + image.preview}
            isLoading={false}
            onSelect={async (image) => {
              // download selected json
              const req = await fetch(`/wp-content/coamakerbasic/templates/${image.json}`);
              const json = await req.json();
              // just inject it into store
              store.loadJSON(json, true);
            }}
            rowsNumber={3}
            getCredit={(image) => image.name}
          />
          </div>
        } />
      </Tabs>
    </div>
  );
});

const TemplatesSection = {
  name: 'custom-templates',
  Tab: (props) => (
    <SectionTab name="Templates" {...props}>
      <FaGlobeAmericas></FaGlobeAmericas>
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: TemplatesPanel,
};

const AVAILABLE_SIZES = [
  { width: 1000, height: 1000, first: 1, last: "1 (Switzerland, Vatican City)" },
  { width: 1375, height: 1000, first: 8, last: "11 (Israel)" },
  { width: 1429, height: 1000, first: 7, last: "10 (Brazil)" },
  { width: 1500, height: 1000, first: 2, last: "3 (Japan, France, Kenya)" },
  { width: 1600, height: 1000, first: 5, last: "8 (Poland, Sweden, Palau)" },
  { width: 1665, height: 999, first: 3, last: "5 (Germany, Nicaragua, Lithuania)" },
  { width: 1900, height: 1000, first: 10, last: "19 (USA)" },
  { width: 2000, height: 1000, first: 1, last: "2 (UK, North Korea, USSR)" }
];

const OverlaySection = {
  name: 'overlays',
  Tab: (props) => (
    <SectionTab name="Tools" {...props} >
      <Icon iconSize={20} icon="build" />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);

    async function loadImages() {
      const time = (new Date()).getTime();
      const shapesUrl = "/wp-content/coamakerbasic/overlays/0_overlays.json?=ver";
      const shapeFetch = shapesUrl + time;
      console.group(shapeFetch);
      fetch(shapeFetch)
        .then(function (resp) {
          return resp.json();
        })
        .then(function (data) {
          setImages(data);
        });
      //setImages(data.url);
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    React.useEffect(() => {
      loadImages();
    }, []);

    var filteredImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if ((image["pro"] === false) || (image["pro"] === true)) {
        filteredImages.push(images[i]);
      }
    }

    return (
      <div className="Templates-Panel-32" style={{ height: "86%", display: "flex", flexDirection: "column", overflowY: "auto" }}>
        <FlagAdsense></FlagAdsense>
        <Tabs
          animate={true}
          key={"vertical"}
          vertical={false}
        >
          <Tab id="fra" title="Ratio" panel={
            <div><div style={{ marginBottom: '20px' }}> <b>Custom Sizes with PRO</b>
              <div className="coam-promotion-panel">With PRO you can give your flag every size you need.</div>
              <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
              {AVAILABLE_SIZES.map(({ width, height, first, last }, i) => (
                <Button
                  key={i}
                  style={{ width: '100%', marginBottom: '20px' }}
                  onClick={() => {
                    store.setSize(width, height);
                  }}
                >
                  {first}:{last}
                </Button>
              ))}
            </div>
            </div>
          } />
          <Tab id="ftx" title="Text" panel={
            <div style={{ height: '100%' }} className="coa-template-container">
              <b>Add Text is a PRO feature</b>
              <div className="coam-promotion-panel">Add country names and mottos to you your flags.</div>
              <div className="coam-promotion-panel">Use carefully selected fonts or switch to dozens of others.</div>
              <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
              <div><img src="/wp-content/coamakerbasic/fonts/Text_Preview.jpg" width="100%" /></div>
            </div>

          } />
          <Tab id="fol" title="Overlays" panel={
            <div>        <ImagesGrid
              images={filteredImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/${url}.svg`
                }
                image.url = url;
                const { width, height } = await getImageSize(image.url);
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  keepRatio: false,
                  x: (store.width - width) / 2,
                  y: (store.height - height) / 2
                });
              }}
              rowsNumber={2}
              isLoading={false}
              loadMore={false}
            />
            </div>
          } />
        </Tabs>
      </div>
    );
  }),
};

const DragButton = ({ onSelect, ...props }) => {
  return (
    <Button
      {...props}
      draggable
      className="polotno-close-panel"
      onClick={() => onSelect()}
      onDragStart={() => {
        unstable_registerNextDomDrop(({ x, y }) => {
          onSelect({ x, y });
        });
      }}
      onDragEnd={(e) => {
        unstable_registerNextDomDrop(null);
      }}
    />
  );
};

const dntTutorials = [
  { title: "How to Adjust Colors", videoId: "hbRrq2NFSQs" },
  { title: "How to Save Designs (PRO)", videoId: "BId_BGluloU" }
];

const HelpPanel = observer(({ store }) => {

  return (
    <div className="coaChargesContainer" style={{ height: "73vh", display: "flex", flexDirection: "column", overflowY: "auto" }}>
      {/* Map through videos array to render a TutorialModal for each video */}
      {dntTutorials.map((video, index) => (
        <TutorialModal key={index} title={video.title} videoId={video.videoId} />
      ))}
    </div>
  );
});

const HelpSection = {
  name: 'prints',
  Tab: (props) => (
    <SectionTab name="Tutorial" {...props}>
      <Icon iconSize={20} icon="learning" />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: HelpPanel,
};



const CoaPanel = observer(({ store }) => {

  return (
    <div className="Templates-Panel-32" style={{ height: "86%", display: "flex", flexDirection: "column", overflowY: "auto", overflowX: "hidden" }}>
      <b>Create Coats of Arms</b>
      <div className="coam-promotion-panel">Use hundreds of heraldic symbols and shields in CoaMaker.</div>
      <div className="coam-promotion-panel">Make custom heraldry designs and family crests.</div>
      <div className="coam-info-button-div"><a href="https://coamaker.com" target="_blank"><span className="coam-info-button">Try it now</span></a></div>
      <div style={{ textAlign: "center" }}><a href="https://coamaker.com" target="_blank"><img src="/wp-content/coamakerbasic/coageneral/Brazil.jpeg" width="80%" /></a></div>
      <div style={{ textAlign: "center" }}><a href="https://coamaker.com" target="_blank"><img src="/wp-content/coamakerbasic/coageneral/Lamb.jpeg" width="80%" /></a></div>
      <div style={{ textAlign: "center" }}><a href="https://coamaker.com" target="_blank"><img src="/wp-content/coamakerbasic/coageneral/Longship.jpeg" width="80%" /></a></div>
    </div>
  );
});

const CoaSection = {
  name: 'custom-uploads2',
  Tab: (props) => (
    <SectionTab name="Heraldry" {...props}>
      <img src="/wp-content/coamakerbasic/coageneral/coamakerlogowr.svg" className="coa-red" width="15px" />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: CoaPanel,
};

const HerotPanel = observer(({ store }) => {

  return (
    <div className="Templates-Panel-32" style={{ height: "86%", display: "flex", flexDirection: "column", overflowY: "auto", overflowX: "hidden" }}>
      <b>Make Tokens for Your Games</b>
      <div className="coam-promotion-panel">Make tokens with borders and transparent background.</div>
      <div className="coam-promotion-panel">Create portraits with our AI or browser our library.</div>
      <div className="coam-info-button-div"><a href="https://heroictoken.com" target="_blank"><span className="coam-info-button">Try it now</span></a></div>
      <div style={{ textAlign: "center" }}><a href="https://heroictoken.com" target="_blank"><img src="/wp-content/coamakerbasic/coageneral/firetoken.webp" width="80%" /></a></div>
      <div style={{ textAlign: "center" }}><a href="https://heroictoken.com" target="_blank"><img src="/wp-content/coamakerbasic/coageneral/elftoken.webp" width="80%" /></a></div>
      <div style={{ textAlign: "center" }}><a href="https://heroictoken.com" target="_blank"><img src="/wp-content/coamakerbasic/coageneral/vampiretoken.webp" width="80%" /></a></div>
    </div>
  );
});

const HerotSection = {
  name: 'heroictoken',
  Tab: (props) => (
    <SectionTab name="Tokens" {...props}>
      <img src="/wp-content/coamakerbasic/coageneral/heroictokenlogowr.svg" className="coa-red" width="20px" />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: HerotPanel,
};

const AiSection = {
  name: 'ai',
  Tab: (props) => (
    <SectionTab name="AI" {...props}>
      <BisBot size="20" />
    </SectionTab>
  ),

  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);
    const [secFlagImages, setSecFlagImages] = React.useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);



    async function loadImages() {
      const time = new Date().getTime();
      const animalUrl = "/wp-content/coamakerbasic/coa/0_flag.json?=ver";
      const animalFetch = animalUrl + time;

      try {
        const resp = await fetch(animalFetch);
        const data = await resp.json();

        // Generate a random number between 0 and 1
        const randomNumber = Math.random();
        let source;

        if (randomNumber < 0.6) {
          source = 'com'; // 60% chance for "com"
        } else if (randomNumber < 0.75) {
          source = 'cre'; // 15% chance for "cre"
        } else {
          source = 'sym'; // 25% chance for "sym"
        }

        // Filter the JSON entries based on the 'sec' property
        const filteredData = data.filter(entry => {
          const sec = entry.sec;
          const pro = entry.pro;
          return sec === source && pro === false;
        });

        // Set the images state with the filtered data
        setImages(filteredData);

        // Filter again to get only 'sec' flag images
        let secFlagFilteredData;
        if (Math.random() < 0.7) {
          const arrayFlags = ['shape/1-1', 'shape/1-2', 'shape/1-3', "shape/2-1", "shape/3-1", "shape/25-2", "shape/dia_slim"];
          // 50% chance to use the arrayFlags in secFlagFilteredData
          secFlagFilteredData = arrayFlags.map(url => ({ url, sec: 'flag' }));
        } else {
          // 50% chance to use the randomFlag in secFlagFilteredData
          secFlagFilteredData = data.filter(entry => {
            const sec = entry.sec;
            const pro = entry.pro;
            return sec === 'flag' && pro === false;
          });
        }

        // Set the sec flag images state
        setSecFlagImages(secFlagFilteredData);
      } catch (error) {
        console.error("Error loading images:", error);
      }

      // Wait for 3 seconds before resolving
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }





    React.useEffect(() => {
      loadImages();
    }, []);

    //console.log(secFlagImages);

    // Function to download SVG file and get its content as string
    async function urlToString(url) {
      const req = await fetch(url, { mode: 'cors' });
      const svgString = await req.text();
      return svgString;
    }

    // Function to parse SVG string into DOM
    function parseSVG(svgString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgString, 'image/svg+xml');
      return doc;
    }

    // Regular expressions for color attributes
    const fillColorRegex = /fill="(#[0-9A-Fa-f]{3,6}|rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|\b(black|white|red|green|blue|yellow|orange|purple|pink)\b)"/g;
    const strokeColorRegex = /stroke="(#[0-9A-Fa-f]{3,6}|rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|\b(black|white|red|green|blue|yellow|orange|purple|pink)\b)"/g;
    const styleColorRegex = /style="(.*?)"/g;



    // Function to parse SVG string into DOM
    function parseSVG(svgString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgString, 'image/svg+xml');
      return doc;
    }


    const handleAddRandomSymbol = async () => {
      try {
        setIsButtonDisabled(true);
        if (images.length === 0 || secFlagImages.length === 0) {
          return;
        }

        let ids = store.pages
          .map((page) => page.children.map((child) => child.id))
          .flat();
        store.deleteElements(ids);


        // For the symbol
        const randomIndex = Math.floor(Math.random() * images.length);
        const randomSymbol = images[randomIndex];
        let url = randomSymbol.url;
        if (url.search(".svg") === -1) {
          url = `/wp-content/coamakerbasic/${url}.svg`;
        }
        randomSymbol.url = url;

        // Fetch and parse SVG for the old image
        const svgString = await urlToString(randomSymbol.url);

        // For the flag
        const randomIndexSecFlag = Math.floor(Math.random() * secFlagImages.length);
        const randomFlag = secFlagImages[randomIndexSecFlag];
        let urlSecFlag = randomFlag.url;
        if (urlSecFlag.search(".svg") === -1) {
          urlSecFlag = `/wp-content/coamakerbasic/${urlSecFlag}.svg`;
        }
        randomFlag.url = urlSecFlag;

        // Fetch and parse SVG for the new image
        const svgStringSecFlag = await urlToString(randomFlag.url);
        //console.log(svgStringSecFlag);

        // Create a map to store color replacements
        const symbolColorReplacementMap = new Map();
        const flagColorReplacementMap = new Map();

        const baseColorArray = [
          '#FFFFFF', '#000000',
        ];

        // Define arrays for blue, red, and yellow colors
        const blueColors = ['#003087', '#74ACDF', '#005BBB', '#00778B', '#00267F',];
        const redColors = ['#C60C30', '#B22234', '#B40A2D', '#D52B1E', '#D52B1E',];
        const yellowColors = ['#F2A800', '#FFCC00', '#FDEF42', '#FF9933'];
        const greenColors = ['#006A44', '#008C45', '#1EB53A', '#01411C', '#128807'];

        // Randomly select one color from each category
        const randomBlueColor = blueColors[Math.floor(Math.random() * blueColors.length)];
        const randomRedColor = redColors[Math.floor(Math.random() * redColors.length)];
        const randomYellowColor = yellowColors[Math.floor(Math.random() * yellowColors.length)];
        const randomGreenColor = greenColors[Math.floor(Math.random() * yellowColors.length)];

        // Combine all selected colors into the final color array
        const colorArray = [
          ...baseColorArray,
          randomBlueColor,
          randomRedColor,
          randomYellowColor,
          randomGreenColor,
        ];

        // Replace fill attributes with new colors
        const modifiedSvgStringFill = svgString.replace(fillColorRegex, (match) => {
          // Check if this color has been replaced before
          if (symbolColorReplacementMap.has(match)) {
            return symbolColorReplacementMap.get(match);
          }
          const availableColors = colorArray.filter(color => !symbolColorReplacementMap.has(color));
          if (availableColors.length === 0) {
            // No available colors left, return the original color
            return match;
          }
          const randomColorIndex = Math.floor(Math.random() * availableColors.length);
          const newColor = availableColors[randomColorIndex];
          // Store the mapping of old color to new color
          symbolColorReplacementMap.set(match, newColor);
          // Remove the used color from colorArray
          const indexToRemove = colorArray.indexOf(newColor);
          if (indexToRemove !== -1) {
            colorArray.splice(indexToRemove, 1);
          }
          //console.log(`Replacing fill attribute with ${newColor}`);
          return `fill="${newColor}"`;
        });

        // Replace stroke attributes with new colors
        const modifiedSvgStringStroke = modifiedSvgStringFill.replace(strokeColorRegex, (match) => {
          // Check if this color has been replaced before
          if (symbolColorReplacementMap.has(match)) {
            return symbolColorReplacementMap.get(match);
          }
          const availableColors = colorArray.filter(color => !symbolColorReplacementMap.has(color));
          if (availableColors.length === 0) {
            // No available colors left, return the original color
            return match;
          }
          const randomColorIndex = Math.floor(Math.random() * availableColors.length);
          const newColor = availableColors[randomColorIndex];
          // Store the mapping of old color to new color
          symbolColorReplacementMap.set(match, newColor);
          // Remove the used color from colorArray
          const indexToRemove = colorArray.indexOf(newColor);
          if (indexToRemove !== -1) {
            colorArray.splice(indexToRemove, 1);
          }
          //console.log(`Replacing stroke attribute with ${newColor}`);
          return `stroke="${newColor}"`;
        });

        // Replace style attributes with new fill color
        const modifiedSvgStringStyle = modifiedSvgStringStroke.replace(styleColorRegex, (match) => {
          // Extract the existing style content
          const existingStyle = match.match(/style="(.*?)"/)[1];
          // Replace only the fill color within the style
          const newStyle = existingStyle.replace(/fill:(#[0-9A-Fa-f]{3,6}|rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|\b(black|white|red|green|blue|yellow|orange|purple|pink)\b)/g, (fillMatch) => {
            // Check if this color has been replaced before
            if (symbolColorReplacementMap.has(fillMatch)) {
              return `fill:${symbolColorReplacementMap.get(fillMatch)}`;
            }
            const availableColors = colorArray.filter(color => !symbolColorReplacementMap.has(color));
            if (availableColors.length === 0) {
              // No available colors left, return the original color
              return fillMatch;
            }
            const randomColorIndex = Math.floor(Math.random() * availableColors.length);
            const newColor = availableColors[randomColorIndex];
            // Store the mapping of old color to new color
            symbolColorReplacementMap.set(fillMatch, newColor);
            // Remove the used color from colorArray
            const indexToRemove = colorArray.indexOf(newColor);
            if (indexToRemove !== -1) {
              colorArray.splice(indexToRemove, 1);
            }
            //console.log(`Replacing fill color within style with ${newColor}`);
            return `fill:${newColor}`;
          });
          // Replace the entire style attribute with the modified style content
          return `style="${newStyle}"`;
        });

        // Fetch and parse the modified SVG
        const modifiedDoc = parseSVG(modifiedSvgStringStyle);

        // Serialize SVG back into a string
        const serializer = new XMLSerializer();
        const newSvgString = serializer.serializeToString(modifiedDoc);

        // Replace fill attributes with new colors for randomFlag
        const modifiedSvgStringFillFlag = svgStringSecFlag.replace(fillColorRegex, (match) => {
          // Check if this color has been replaced before
          //console.log("colorArray");
          //console.log(colorArray);
          if (flagColorReplacementMap.has(match)) {
            return flagColorReplacementMap.get(match);
          }
          const availableColors = colorArray.filter(color => !flagColorReplacementMap.has(color));
          if (availableColors.length === 0) {
            // No available colors left, return the original color
            return match;
          }
          const randomColorIndex = Math.floor(Math.random() * availableColors.length);
          const newColor = availableColors[randomColorIndex];
          // Store the mapping of old color to new color
          flagColorReplacementMap.set(match, newColor);
          // Remove the used color from colorArray
          const indexToRemove = colorArray.indexOf(newColor);
          if (indexToRemove !== -1) {
            colorArray.splice(indexToRemove, 1);
          }
          //console.log(`Replacing fill attribute with ${newColor}`);
          return `fill="${newColor}"`;
        });

        // Replace stroke attributes with new colors for randomFlag
        const modifiedSvgStringStrokeFlag = modifiedSvgStringFillFlag.replace(strokeColorRegex, (match) => {
          // Check if this color has been replaced before
          if (flagColorReplacementMap.has(match)) {
            return flagColorReplacementMap.get(match);
          }
          const availableColors = colorArray.filter(color => !flagColorReplacementMap.has(color));
          if (availableColors.length === 0) {
            // No available colors left, return the original color
            return match;
          }
          const randomColorIndex = Math.floor(Math.random() * availableColors.length);
          const newColor = availableColors[randomColorIndex];
          // Store the mapping of old color to new color
          flagColorReplacementMap.set(match, newColor);
          // Remove the used color from colorArray
          const indexToRemove = colorArray.indexOf(newColor);
          if (indexToRemove !== -1) {
            colorArray.splice(indexToRemove, 1);
          }
          //log(`Replacing stroke attribute with ${newColor}`);
          return `stroke="${newColor}"`;
        });

        // Replace style attributes with new fill color for randomFlag
        const modifiedSvgStringStyleFlag = modifiedSvgStringStrokeFlag.replace(styleColorRegex, (match) => {
          // Extract the existing style content
          const existingStyle = match.match(/style="(.*?)"/)[1];
          // Replace only the fill color within the style
          const newStyle = existingStyle.replace(/fill:(#[0-9A-Fa-f]{3,6}|rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|\b(black|white|red|green|blue|yellow|orange|purple|pink)\b)/g, (fillMatch) => {
            // Check if this color has been replaced before
            if (flagColorReplacementMap.has(fillMatch)) {
              return `fill:${flagColorReplacementMap.get(fillMatch)}`;
            }
            const availableColors = colorArray.filter(color => !flagColorReplacementMap.has(color));
            if (availableColors.length === 0) {
              // No available colors left, return the original color
              return fillMatch;
            }
            const randomColorIndex = Math.floor(Math.random() * availableColors.length);
            const newColor = availableColors[randomColorIndex];
            // Store the mapping of old color to new color
            flagColorReplacementMap.set(fillMatch, newColor);
            // Remove the used color from colorArray
            const indexToRemove = colorArray.indexOf(newColor);
            if (indexToRemove !== -1) {
              colorArray.splice(indexToRemove, 1);
            }
            //console.log(`Replacing fill color within style with ${newColor}`);
            return `fill:${newColor}`;
          });
          // Replace the entire style attribute with the modified style content
          return `style="${newStyle}"`;
        });

        // Fetch and parse the modified SVG for randomFlag
        const modifiedDocFlag = parseSVG(modifiedSvgStringStyleFlag);
        // Serialize SVG back into a string as SVG
        const flagSerializer = new XMLSerializer();
        let newFlagSvgString = flagSerializer.serializeToString(modifiedDocFlag, 'image/svg+xml');


        const isNotSVG = newFlagSvgString.startsWith('<!DOCTYPE html>') || newFlagSvgString.startsWith('<html>');
        // Remove unnecessary whitespace and newlines
        newFlagSvgString = newFlagSvgString.replace(/\n/g, "").replace(/\s{2,}/g, " ");

        // Check if the newFlagSvgString is not an HTML document
        //console.log(randomFlag);




        if (isNotSVG) {
          //console.error('Serialized document is not a valid SVG. Retrying...');
          //console.log(modifiedDocFlag);
          //console.log(newFlagSvgString);
          //console.log(randomFlag);
          handleAddRandomSymbol();
        } else {
          setIsButtonDisabled(false);
        }

        loadImages();


        //let { flagWidth, flagHeight } = await getImageSize('data:image/svg+xml;utf8,' + encodeURIComponent(svgStringSecFlag));
        let flagWidth = store.width;
        let flagHeight = store.height;

        store.activePage.addElement({
          type: "svg",
          src: 'data:image/svg+xml;utf8,' + encodeURIComponent(newFlagSvgString),
          width: flagWidth,
          height: flagHeight,
          keepRatio: true,
        });

        let { width, height } = await getImageSize('data:image/svg+xml;utf8,' + encodeURIComponent(newSvgString));
        let scale = Math.min(store.width / width, store.height / height);
        scale *= 0.3;
        width = width * scale;
        height = height * scale;
        let x = (store.width - width) / 2;
        let y = (store.height - height) / 2;

        // Add modified SVG to the canvas
        const randomNumber = Math.random();
        if (randomNumber <= 0.5) {
          // Call the store.activePage.addElement function with a 70% probability
          store.activePage.addElement({
            type: "svg",
            src: 'data:image/svg+xml;utf8,' + encodeURIComponent(newSvgString),
            width,
            height,
            keepRatio: true,
            x,
            y,
          });

        }
      } catch (error) {
        console.error("An error occurred: ", error);
        // Handle any errors here
      } finally {
        setIsButtonDisabled(false);
      }
    };

    return (
      <div className="Templates-Panel-32" style={{ height: "90%", display: "flex", flexDirection: "column", overflowY: "auto", overflowX: "hidden" }}>
        <FlagAdsense></FlagAdsense>
        <div><b>Get Inspired by Our Bot</b></div>
        <div style={{ marginBottom: "20px" }}>Click on the button to generate random flags. Edit the flags until they fit your needs.</div>
        <div>
          <Button
            icon="random"
            style={{ width: '100%' }}
            onClick={handleAddRandomSymbol}
            disabled={isButtonDisabled}
          >
            Create a Random Flag
          </Button>
        </div>
        <div className="coam-info-container">
          <hr />
          <div className="coam-info-head">More Elements with PRO</div>
          <div className="coam-info-text">Save your flags, and use hundreds of extra elements.</div>
          <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Unlock all elements</span></a></div>
        </div>
      </div >
    );
  }),
};

const SavePanel = observer(({ store }) => {

  return (
    <div style={{ height: '100%' }}>
      <TutorialModal key="1" title="Save your designs with PRO" videoId="BId_BGluloU" />
      <div className="coam-promotion-panel">With a PRO account, you can save your designs online and continue editing it later.</div>
      <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
    </div>
  );
});

const SaveSection = {
  name: 'custom-save',
  Tab: (props) => (
    <SectionTab name="Save" {...props}>
      <Icon iconSize={20} icon="floppy-disk" />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: SavePanel,
};

const Opacity = () => null;
const SvgFilters = () => null;
const ImageRemoveClip = () => null;
const ImageFilters = () => null;
const ImageFitToBackground = () => null;

const sections = [
  AiSection,
  LayersSection,
  ShapeSection,
  SymbolSection,
  TemplatesSection,
  OverlaySection,
  HelpSection,
  SaveSection,
  CoaSection,
  HerotSection
];

export const App = () => {
  const inputRef = React.useRef();

  return (
    <div
      style={{
        display: "flex",
        height: "90vh",
        width: "100%",
        overflowY: "hidden",
      }}
    >


      <PolotnoContainer className="polotno-app-container bp5-dark">

        <SidePanelWrap className="pro-side-panel">
          <NavbarContainer className="bp5-navbar coam-navbar-promo flagfree" >
            <NavInner>
              <Navbar.Group align={Alignment.LEFT} className="coam-navbar-promo-left">
                <div className="coam-promotion-top">GO PRO, unlock all elements, and save your designs. </div>
              </Navbar.Group>
              <Navbar.Group align={Alignment.RIGHT} className="coam-navbar-promo-right">
                <div className="coam-sub-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-sub-button">Learn more</span></a></div>
              </Navbar.Group>
            </NavInner>
          </NavbarContainer>
          <SidePanel store={store} sections={sections} defaultSection="shapes" />
        </SidePanelWrap>
        <WorkspaceWrap>
          <Toolbar store={store} downloadButtonEnabled={true} components={{
            Opacity, SvgFilters, ImageRemoveClip, ImageFilters, ImageFitToBackground,
          }} >
          </Toolbar>

          <Workspace
            store={store}
            backgroundColor="#c2c2c2"
            pageBorderColor='#383e47'
            pageControlsEnabled={false}
            onKeyDown={(e, store) => {
              const activeElement = document.activeElement;
              const isTextInput = activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.isContentEditable;

              if (isTextInput) {
                return; // Do nothing if the user is focused on a text input field
              }

              if (e.key === 'Backspace' || e.key === 'Delete') {
                e.preventDefault(); // Prevent the browser's default delete action
                const selectedElements = store.selectedElements;
                if (selectedElements && selectedElements.length > 0) {
                  const ids = selectedElements.map(element => element.id);
                  store.deleteElements(ids);
                }
                return;
              }

              if (e.metaKey && e.key === 'a') {
                e.preventDefault(); // Prevent the browser's default select all action
                const allElements = store.pages
                  .map((page) => page.children)
                  .flat();
                store.selectElements(allElements.map(element => element.id));
                return;
              }

              if (e.metaKey && e.key === 'z') {
                e.preventDefault(); // Prevent the browser's default undo action
                store.history.undo();
                return;
              }

              if ((e.metaKey && e.key === 'y') || (e.metaKey && e.shiftKey && e.key === 'z')) {
                e.preventDefault(); // Prevent the browser's default redo action
                store.history.redo();
                return;
              }
              handleHotkey(e, store);

            }}
          />
          <ZoomButtons store={store} />
        </WorkspaceWrap>
      </PolotnoContainer>
      <Adsense
        client="ca-pub-7706095824493443"
        slot="1306165667"
        style={{ display: 'block' }}
        layout="in-article"
        format="fluid"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>

  );
};



ReactDOM.render(<App />, document.getElementById("root"));

export default App;